var React = require('react');

function LinkedinFooter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1667 0c920 0 1667 746 1667 1667 0 920-746 1667-1667 1667C747 3334 0 2588 0 1667 0 747 746 0 1667 0zm-215 1336h342v175h5c48-86 164-175 338-175 361 0 428 225 428 517v596h-357v-528c0-126-3-288-186-288-186 0-214 137-214 279v537h-357V1336zm-247-309c0 102-83 186-186 186-102 0-186-83-186-186 0-102 83-186 186-186 102 0 186 83 186 186zm-371 309h371v1113H834V1336z"}));
}

LinkedinFooter.defaultProps = {"viewBox":"0 0 3333 3333","shapeRendering":"geometricPrecision","textRendering":"geometricPrecision","imageRendering":"optimizeQuality","fillRule":"evenodd","clipRule":"evenodd"};

module.exports = LinkedinFooter;

LinkedinFooter.default = LinkedinFooter;
